import { DollarSign, PoundSterlingIcon } from "lucide-react";
import React from "react";
import { NavLink } from "react-router-dom";

const Bell = () => <span className="material-icons">notifications</span>;
const Lock = () => <span className="material-icons">lock</span>;
const Menu = () => <span className="material-icons">menu</span>;
const Settings = () => <span className="material-icons">settings</span>;
const User = () => <span className="material-icons">person</span>;
const ArrowRightIcon = () => <span className="material-icons">arrow_forward</span>;

const Item = ({ to, icon, label, isCollapsed }: {
  to: string;
  icon: React.ReactNode;
  label: string;
  isCollapsed?: boolean;
}) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      [
        "flex items-center gap-3 px-4 py-3 rounded-[12px] transition relative group",
        isActive ? "bg-[#e9f4ea] text-[#1f2c22]" : "hover:bg-black/[0.04] text-[#1f2c22]/80",
        isCollapsed ? "justify-center" : "",
      ].join(" ")
    }
    title={isCollapsed ? label : ""}
  >
    <span className="h-9 w-9 rounded-full grid place-items-center bg-[#8CC38F] text-[#17331F] flex-shrink-0">
      {icon}
    </span>
    {!isCollapsed && <span className="font-medium">{label}</span>}

    {/* Tooltip for collapsed state */}
    {isCollapsed && (
      <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50">
        {label}
      </div>
    )}
  </NavLink>
);

const ProfileSidebar = (
  { isProfileRoute = false }: { isProfileRoute?: boolean }
) => {
  return (
    <div className={ `"w-64 flex-shrink-0 h-full sticky ${isProfileRoute ? "top-[97px]" : "top-[16px]"}` }>
      <div className="h-full overflow-auto rounded-[16px] bg-white shadow border p-3">
        <div className="flex items-center justify-between mb-4">
          <div className="px-3 py-2">
            <div className="font-semibold text-[#2b2f31]">Settings</div>
            <div className="text-xs text-[#8b8f93]">You can find all settings here.</div>
          </div>
        </div>

        <div className="mt-2 space-y-1">
          <Item to="/dashboard/profile/details" icon={<User />} label="My Profile" />
          <Item to="/dashboard/accountmanagement" icon={<Lock />} label="Account Management" />
          <Item to="/dashboard/preferences" icon={<Settings />} label="Preferences" />
          {/* <Item to="/dashboard/chat" icon={<MessageCircle />} label="Chat" /> */}
          <Item to="/dashboard/notification" icon={<Bell />} label="Notification" />
          <Item to="/dashboard/plans" icon={<PoundSterlingIcon />} label="Plans & Billing" />
        </div>
      </div>
    </div>
  );
};

export default ProfileSidebar;